// @ts-strict-ignore
import * as React from 'react';
import { useSelector } from 'react-redux';
import { getReleaseStepFromState } from '../helpers';
import { RootState } from '../reducers/reducers';
import { ReleaseStepStatus } from '../types';
import { ReleaseStepComponentProps } from '../typescriptHelpers';
import {
    selectChecklistItemsForReleaseStepCount,
    selectCompletedChecklistItemsForReleaseStepCount,
    selectReleaseStepHasBlockedAutomation,
    selectReleaseStepHasFailedAutomation,
} from '../selectors/selectors';
import { ReleaseStepOrStepRunContainerBase } from '@/components/StepRunContainer';

interface ReleaseStepContainerProps extends ReleaseStepComponentProps {}

const ReleaseStepContainer: React.FC<ReleaseStepContainerProps> = (props) => {
    const { releaseId, releaseStepType } = props;

    const hasFailedEnabledAutomation = useSelector((state: RootState) =>
        selectReleaseStepHasFailedAutomation(state, props.appId, releaseId, releaseStepType),
    );

    const hasBlockedEnabledAutomation = useSelector((state: RootState) =>
        selectReleaseStepHasBlockedAutomation(state, props.appId, releaseId, releaseStepType),
    );

    const checklistItemsCount = useSelector((state: RootState) =>
        selectChecklistItemsForReleaseStepCount(state, releaseId, releaseStepType),
    );

    const completedChecklistItemsCount = useSelector((state: RootState) =>
        selectCompletedChecklistItemsForReleaseStepCount(state, releaseId, releaseStepType),
    );

    const releaseStepStatus: ReleaseStepStatus = useSelector(
        (state: RootState) => getReleaseStepFromState(releaseStepType, releaseId, state).status,
    );

    const releaseStepStatusReasonString = useSelector(
        (state: RootState) => getReleaseStepFromState(releaseStepType, releaseId, state).statusReasonString,
    );

    return (
        <ReleaseStepOrStepRunContainerBase
            {...props}
            checklistItemsCount={checklistItemsCount}
            completedChecklistItemsCount={completedChecklistItemsCount}
            stepRunComponentProps={null}
            hasFailedEnabledAutomation={hasFailedEnabledAutomation}
            hasBlockedEnabledAutomation={hasBlockedEnabledAutomation}
            stepStatus={releaseStepStatus}
            stepStatusReasonString={releaseStepStatusReasonString}
        />
    );
};

export default ReleaseStepContainer;
